const elementClasses: Record<string, string> = {
  img: 'bg-cw-deep-purple p-2 rounded-lg w-12 opacity-1 z-20 transition-all duration-500 ease-in-out group-hover:opacity-[.4]',
}

export const SocialMediaElements = ({
  onChatbotClick,
}: {
  onChatbotClick?: () => void
}) => {
  return (
    <div className="flex items-start gap-3 col-span-3 flex-wrap md:flex-nowrap justify-start md:justify-end my-6 sm:my-0 sm:pr-16 lg:pr-0">
      <a
        className="relative group"
        target="_blank"
        href="https://discord.com/invite/uE5AtaKxdk"
        aria-label="Join WLTH on Discord"
      >
        <img
          className={`${elementClasses.img}`}
          src="/images/socials/discordIconLtPrpl.webp"
          alt="Discord"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://x.com/wlthxyz"
        aria-label="Follow WLTH on X (Twitter)"
      >
        <img
          className={`${elementClasses.img}`}
          src="/images/socials/twitterIconLtPrpl.webp"
          alt="X (Twitter)"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://www.linkedin.com/company/80197557/"
        aria-label="Follow WLTH on LinkedIn"
      >
        <img
          className={`${elementClasses.img}`}
          src="/images/socials/linkedinIconLtPrpl.webp"
          alt="LinkedIn"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://t.me/WLTHxyz"
        aria-label="Join WLTH on Telegram"
      >
        <img
          className={`${elementClasses.img}`}
          src="/images/socials/telegramIconLtPrpl.webp"
          alt="Telegram"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://www.youtube.com/@wlthxyz"
        aria-label="Join WLTH on YouTube"
      >
        <img
          className={`${elementClasses.img} text-cw-electric-purple`}
          src="/images/socials/youtube.webp"
          alt="YouTube"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://www.facebook.com/profile.php?id=61583968691590"
        aria-label="Join WLTH on Facebook"
      >
        <img
          className={`${elementClasses.img} text-cw-electric-purple`}
          src="/images/socials/facebook-outlined.webp"
          alt="Facebook"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://www.tiktok.com/@wlthxyz"
        aria-label="Join WLTH on TikTok"
      >
        <img
          className={`${elementClasses.img} text-cw-electric-purple`}
          src="/images/socials/tik-tok-outlined.webp"
          alt="TikTok"
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        className="relative group"
        target="_blank"
        href="https://www.instagram.com/wlthxyz/"
        aria-label="Join WLTH on Instagram"
      >
        <img
          className={`${elementClasses.img} text-cw-electric-purple`}
          src="/images/socials/instagram-outlined.webp"
          alt="Instagram"
          loading="lazy"
          decoding="async"
        />
      </a>
      <button
        className={`relative cursor-pointer border-none ${elementClasses.img} hover:opacity-[.4] px-2 py-2.5`}
        onClick={onChatbotClick}
        aria-label="Open chatbot"
      >
        <img
          src="/images/wlth/chatbot.webp"
          alt=""
          width={64}
          height={54}
          className="w-full h-full"
          loading="lazy"
          decoding="async"
        />
      </button>
    </div>
  )
}
